import { render, staticRenderFns } from "./SupportCreate.vue?vue&type=template&id=0542517c&scoped=true&"
import script from "./SupportCreate.vue?vue&type=script&lang=js&"
export * from "./SupportCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542517c",
  null
  
)

export default component.exports